export default __webpack_public_path__ + "static/book5555-22fec7c0bb969bf7d29354d440d26151.png";